import React from 'react'
// import EtCreateUserImprintGratitudeComp from '@/features/userMagic/userImprint/EtCreateUserImprintGratitudeComp'
import EtCreateUserImprintGratitudeComp from '@/pages/home/web/userImprint/EtCreateUserImprintGratitudeComp'
import {
    XCircleIcon
  } from "@heroicons/react/24/solid"

const EtModalCreateUserImprintGratitude = ({
  isOpen, 
  userId, 
  userOrgId, 
  triggeringUrl, 
  onClose, 
  refetchOnSuccess = null, // ✅ 08 Apr 2025 - New prop 
  }) => {

  // First Created - 18 Dec 2024
  // Author - Atul Pandey
  // Inherited from EtModalCreateUserImprintRole
  // Updated - 08 Apr 2025 - added refetchOnSuccess
  
  // console.log('triggering url', triggeringUrl)

  if (!isOpen) return null


  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-70 flex justify-center items-start font-poppins overflow-y-auto p-4">
      <div className="bg-black p-5 rounded-lg shadow-lg shadow-black relative w-full max-w-4xl">
        <div
          className="absolute top-2 right-2 m-2 font-bold rounded-full cursor-pointer h-7 w-7 flex justify-center items-center"
          onClick={onClose}
        >
          <XCircleIcon className='text-orange-600 rounded-full hover:text-red-600 h-7 w-7'/>
        </div>
        <EtCreateUserImprintGratitudeComp 
          userId={userId} 
          userOrgId={userOrgId} 
          triggeringUrl={triggeringUrl} 
          onClose={onClose}
          refetchOnSuccess={refetchOnSuccess}  // ✅ 08 Apr 2025 - New
        />
      </div>
    </div>
  )
}

export default EtModalCreateUserImprintGratitude